import { j as e } from "./jsx-runtime-DmTjM30f.mjs";
import * as a from "react";
import { forwardRef as i } from "react";
import { c as n } from "./index.js-Cr0Rsuyz.mjs";
import { N as f } from "./number-indicator-D6y1_icz.mjs";
function h(t, s) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: s
  }, t), /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8 3.75a2 2 0 0 0-2 2v12.5a2 2 0 1 0 4 0V5.75a2 2 0 0 0-2-2M16 3.75a2 2 0 0 0-2 2v12.5a2 2 0 1 0 4 0V5.75a2 2 0 0 0-2-2"
  }));
}
var d = n(/* @__PURE__ */ i(h));
function u(t, s) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: s
  }, t), /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.971 3.81c-1.83-1.16-4.221.156-4.221 2.323v11.732c0 2.168 2.39 3.483 4.221 2.324l9.262-5.866c1.705-1.08 1.705-3.567 0-4.647z"
  }));
}
var x = n(/* @__PURE__ */ i(u));
const p = ({
  isPlaying: t,
  currentPage: s,
  totalPages: r,
  transitionDurationMs: c = 300,
  onPlayChange: o,
  onClickAll: m
}) => {
  const l = t ? "일시정지" : "재생";
  return /* @__PURE__ */ e.jsxs("div", { className: "flex h-32 w-[258px] items-center pc:h-48 pc:w-[500px]", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "relative flex items-center justify-center", children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          "aria-label": l,
          className: "relative flex size-32 shrink-0 items-center justify-center pc:mr-4",
          onClick: o,
          title: l,
          type: "button",
          children: /* @__PURE__ */ e.jsx("div", { className: "size-14 pc:size-24", children: t ? /* @__PURE__ */ e.jsx(d, { className: "size-full" }) : /* @__PURE__ */ e.jsx(x, { className: "size-full" }) })
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "absolute right-4 h-8 w-1 bg-line-neutral-weak2 pc:right-2 pc:h-16" })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative ml-6 mr-10 flex grow items-center", children: [
      /* @__PURE__ */ e.jsx("div", { className: "h-1 w-full rounded-10 bg-fill-neutral-weak3 pc:h-2" }),
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: "absolute h-2 rounded-[2rem] bg-fill-neutral-main transition-transform pc:h-4",
          style: {
            width: `${1 / r * 100}%`,
            transform: `translateX(${(s - 1) * 100}%)`,
            transitionDuration: `${c}ms`
          }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(f, { currentPage: s, onClickAll: m, totalPages: r })
  ] });
};
p.displayName = "NDS.PageIndicator";
export {
  p as P
};
